import script from "./MyStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./MyStudents.vue?vue&type=script&setup=true&lang=js"

import "./MyStudents.vue?vue&type=style&index=0&id=a8397d5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8397d5a"]])

export default __exports__